{
  "nav.reports": "Reports",
  "reports.title": "Reports",
  "reports.eyebrow.company": "Company performance",
  "reports.eyebrow.team": "Team performance",
  "reports.eyebrow.self": "Your performance",
  "reports.description.company": "What every team did, who led, and what needs attention.",
  "reports.description.team": "What your team did, who led, and what needs attention.",
  "reports.description.self": "What you got done, and how it compares with before.",
  "reports.period.label": "Period",
  "reports.period.today": "Today",
  "reports.period.yesterday": "Yesterday",
  "reports.period.week": "This week",
  "reports.period.lastWeek": "Last week",
  "reports.period.month": "This month",
  "reports.period.lastMonth": "Last month",
  "reports.period.last30": "30 days",
  "reports.period.custom": "Custom",
  "reports.period.from": "From",
  "reports.period.to": "To",
  "reports.period.span": "{range} · compared with {compare}",
  "reports.scope.label": "Whose work",
  "reports.scope.everyone": "Everyone",
  "reports.scope.myTeam": "My whole team",
  "reports.scope.teams": "Teams",
  "reports.scope.people": "People",
  "reports.scope.team": "{name}'s team",
  "reports.scope.clear": "Show everyone",
  "reports.export": "Export CSV",
  "reports.exported": "Report downloaded",
  "reports.loadError": "The report didn't load. Check the connection and try again.",
  "reports.metric.received": "Leads received",
  "reports.metric.rotated_in": "Rotated in",
  "reports.metric.lost_to_rotation": "Lost to rotation",
  "reports.metric.touched": "Leads worked",
  "reports.metric.untouched": "Not contacted",
  "reports.metric.calls": "Calls",
  "reports.metric.whatsapp": "WhatsApp",
  "reports.metric.notes": "Notes",
  "reports.metric.moves": "Status moves",
  "reports.metric.reservations": "Reservations",
  "reports.metric.canceled": "Canceled",
  "reports.metric.meetings": "Meetings held",
  "reports.metric.deals": "Deals closed",
  "reports.metric.sales_value": "Sales value",
  "reports.metric.first_response": "First response",
  "reports.metric.contact_rate": "Contact rate",
  "reports.metric.activity": "All activity",
  "reports.caption.received": "{rotated, plural, =0 {All new to them} other {# rotated in}}",
  "reports.caption.calls": "{whatsapp, plural, =0 {No WhatsApp logged} other {+ # on WhatsApp}}",
  "reports.caption.meetings": "Meetings and viewings held",
  "reports.caption.reservations": "{canceled, plural, =0 {None canceled} other {# canceled}}",
  "reports.caption.deals": "{value} in sales",
  "reports.caption.dealsNone": "No sales value yet",
  "reports.caption.firstResponse": "Median, in working hours",
  "reports.delta.same": "Same",
  "reports.delta.vs": "vs {span}",
  "reports.delta.label": "{direction, select, up {Up} down {Down} other {Unchanged}} {amount} on the compared period",
  "reports.insights.title": "What stands out",
  "reports.insights.empty": "A quiet period: nothing out of the ordinary to report.",
  "reports.insight.rotation": "{count, plural, one {# lead} other {# leads}} ran out of time and rotated to someone else.",
  "reports.insight.rotationMost": "{count, plural, one {# lead} other {# leads}} ran out of time and rotated away, {theirs} of them from {name}.",
  "reports.insight.untouched": "{count, plural, one {# lead} other {# leads}} received with no call, note or move from the owner yet.",
  "reports.insight.slowReply": "New leads waited {duration} of working time for a first reply. Under two hours keeps them warm.",
  "reports.insight.up": "{metric, select, calls {Calls} meetings {Meetings} deals {Closed deals} other {Leads received}} are up {percent} on the compared period.",
  "reports.insight.times": "{metric, select, calls {Calls} meetings {Meetings} deals {Closed deals} other {Leads received}} are {times} times what they were in the compared period.",
  "reports.insight.down": "{metric, select, calls {Calls} meetings {Meetings} deals {Closed deals} other {Leads received}} are down {percent} on the compared period.",
  "reports.insight.topCloser": "{name} closed the most: {count, plural, one {# deal} other {# deals}}.",
  "reports.insight.topCloserValue": "{name} closed the most: {count, plural, one {# deal} other {# deals}} worth {value}.",
  "reports.insight.fastest": "{name} replies to new leads fastest, in {duration}.",
  "reports.insight.topCaller": "{name} made the most calls: {count}.",
  "reports.insight.allContacted": "Every lead received was contacted. Contact rate {percent}.",
  "reports.chart.title": "Activity over time",
  "reports.chart.caption.hour": "By the hour",
  "reports.chart.caption.day": "Day by day",
  "reports.chart.caption.week": "Week by week",
  "reports.chart.total": "in this period",
  "reports.chart.empty": "Nothing recorded in this period",
  "reports.chart.point": "{count} {series} · {label}",
  "reports.chart.week": "Week of {day}",
  "reports.chart.show": "Show",
  "reports.funnel.title": "What became of the leads",
  "reports.funnel.caption": "The leads received in this period, followed to today",
  "reports.funnel.received": "Received",
  "reports.funnel.contacted": "Contacted",
  "reports.funnel.meeting": "Meeting booked",
  "reports.funnel.reserved": "Reserved",
  "reports.funnel.closed": "Closed deal",
  "reports.funnel.share": "{percent} of received",
  "reports.funnel.empty": "No leads were received in this period.",
  "reports.people.title": "Person by person",
  "reports.people.caption": "Select a row to see that person's report",
  "reports.people.col.person": "Person",
  "reports.people.col.role": "Role",
  "reports.people.total": "Total",
  "reports.people.empty": "Nobody to report on yet.",
  "reports.people.open": "Open {name}'s report",
  "reports.feed.title": "Activity log",
  "reports.feed.caption": "{count, plural, =0 {Nothing logged} one {The latest entry} other {The latest # entries}}",
  "reports.feed.empty": "No calls, notes or status moves in this period.",
  "reports.feed.call": "Call",
  "reports.feed.whatsapp": "WhatsApp",
  "reports.feed.note": "Note",
  "reports.feed.move": "Moved to {status}",
  "reports.feed.unnamed": "Unnamed lead",
  "reports.role.admin": "Admin",
  "reports.role.team_leader": "Team leader",
  "reports.role.agent": "Agent"
}
